import { Link } from 'react-router-dom';
import { aboutInfo } from '@/mocks/data';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://taimudaojia.cn/api/search-image?query=Elegant%20minimalist%20geometric%20pattern%20with%20warm%20amber%20and%20cream%20gradients%2C%20soft%20flowing%20abstract%20shapes%2C%20modern%20Asian%20aesthetic%20background%2C%20subtle%20texture%20with%20ink%20wash%20inspiration%2C%20sophisticated%20brand%20visual%2C%20light%20and%20airy%20atmosphere&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 to-primary-800/95"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          开启您的精品内容探索之旅
        </h2>
        <p className="text-background-200 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          {aboutInfo.mission}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/zone1"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50 text-primary-700 font-medium text-sm hover:bg-background-100 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-compass-3-line mr-2"></i>
            立即探索
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-transparent text-background-50 font-medium text-sm border border-background-50/40 hover:bg-background-50/10 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}